import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid-pro';
import { ChangeEvent, useContext } from 'react';
import { GridZipCodeInput } from '@styles/GridStyles';
import { ITextInputProps } from '../../inputs/TextInput';
import { GridRowContext } from './PhoenixGrid';

interface IGridColZipCodeProps extends ITextInputProps {
  params: GridRenderEditCellParams;

  onChange?(event: ChangeEvent<HTMLInputElement>): void;
}

export const GridColZipCode = ({ params, onChange, ...rest }: IGridColZipCodeProps) => {
  const api = useGridApiContext();
  const rowContext = useContext(GridRowContext);
  const { id, field, value } = params;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (rowContext.errors[field]) {
      rowContext.resetError(field);
    }

    api.current.setEditCellValue({ id, field, value: event.target.value });
    onChange?.(event);
  };

  return (
    <GridZipCodeInput
      {...rest}
      unStyled
      value={String(value)}
      error={Boolean(rowContext.errors[field])}
      onChange={handleChange}
    />
  );
};
